<template>
  <div class="mainPage">
    <div style="width: 100%; margin-bottom: 15px;" v-if="viewType === 'LIST'">
      <i class="el-icon-folder-opened"></i>&nbsp;{{$t('process.my')}}
    </div>
    <div v-if="viewType === 'LIST'" class="robotContainer">
      <ProcessItem
              v-for="item in items"
              :key="item.id"
              :item="item"
              :handleClickRun="handleClickRun"
              :handleClickStop="handleClickStop"
              :handleClickConfig="handleClickConfig"
            />
      
    </div>

    <ProcessReview
      v-if="this.viewType === 'REVIEW'"
      :processID="this.currentData.id"
      :processName="this.currentData.name"
      :handleCancel="this.handleGoBackToList"
    />
    
  </div>
</template>

<script>
import ProcessItem from "@/components/process/ProcessItem.vue";
import ProcessReview from "@/views/process/Process_Review.vue";
import { list,online,offline } from "@/api/process";
import { mapState } from "vuex";
const VIEW_TYPE = {
  LIST: "LIST",
  REVIEW: "REVIEW",
};
export default {
  name: "process",
  components: { ProcessItem,ProcessReview },
  data: () => {
    return {
      viewType: VIEW_TYPE.LIST,
      currentData: {},
      items: []
    };
  },
  mounted() {
    this.refreshData();
  },
  computed: {
    ...mapState(["accountInfo"]),
  },
  methods: {
    refreshData() {
      list({
        userID: this.accountInfo.userID,
        companyID: this.accountInfo.companyID
        //...this.searchParams,
      }).then((response) => {
        //this.totalCount = response.data.totalCount;
        this.items = response.data.items;
      });
    },
    handleGoBackToList() {
      this.currentData = {};
      this.viewType = VIEW_TYPE.LIST;
    },
    handleClickRun(pid, pname) {
      this.$confirm(this.$t('process.confirm1a') + pname + this.$t('process.confirm1b'), this.$t('common.popup'), {
        confirmButtonText: this.$t('common.ok'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      })
        .then(() => {
          online({
            userID: this.accountInfo.userID,
            id: pid
          }).then(response => {
            const loading = this.$loading({
              lock: true,
              text: this.$t('process.start'),
              //spinner: 'el-icon-loading',
              background: 'rgba(255, 255, 255, 0.7)'
            });
            setTimeout(() => {
              this.refreshData();
              loading.close();
              this.$message({
                type: "success",
                message: response.message
              });
            }, 3000);
            
          });
        })
        .catch(() => {});
    },
    handleClickStop(pid, pname) {
      this.$confirm(this.$t('process.confirm2a') + pname + this.$t('process.confirm2b'), this.$t('common.popup'), {
        confirmButtonText: this.$t('common.ok'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      })
        .then(() => {
          offline({
            userID: this.accountInfo.userID,
            id: pid
          }).then(response => {
            const loading = this.$loading({
              lock: true,
              text: this.$t('process.stop'),
              //spinner: 'el-icon-loading',
              background: 'rgba(255, 255, 255, 0.7)'
            });
            setTimeout(() => {
              this.refreshData();
              loading.close();
              this.$message({
                type: "success",
                message: response.message
              });
            }, 3000);
          });
        })
        .catch(() => {});
    },
    handleClickConfig(pid, pname) {
      this.viewType = "REVIEW";
      this.currentData.id = pid;
      this.currentData.name = pname;
    }
  }
};
</script>
